import * as React from "react";
import styled from "styled-components";
import { motion, useScroll, useTransform } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // Correct import for navigation hook
import hero from '../../assets/about-hero.png';
import hero_mobile from '../../assets/about-hero_mobile.png';
import about_save from '../../assets/about-save.png'
import about_splurge from '../../assets/about-splurge.png'
import about_save_mobile from '../../assets/about-save_mobile.png'
import about_splurge_mobile from '../../assets/about-splurge_mobile.png'
import about_success from '../../assets/about-success.svg'
import about_success_mobile from '../../assets/about-success_mobile.png'
import { useGoogleLogin } from '@react-oauth/google';
import about_lists from '../../assets/about-lists.png'
import axios from "axios";
import about_join_us from '../../assets/about-join-us.png'
import Snackbar from '@mui/material/Snackbar';
import FeatureImage from '../../assets/feature_image.png'
import { API_BASE_URL } from '../../config/apiConfig';
/* import about_background from '../../assets/about-background.png';
import Modal from '@mui/material/Modal'; // Importing Modal for confirmation
import about_hero_people from '../../assets/about-hero-people.png'
import about_hero_text from '../../assets/about-hero-text.png' */
import { aboutPageImage, featureButtonIcon, joinClubIcon, contentImage, buttonIcon } from '../../assets/images';
import welcome_cat2 from '../../assets/welcome-cat2.png';
import home_people from '../../assets/home-people.png';
import adv1 from '../../assets/adv1.png';
import adv2 from '../../assets/adv2.png';
import adv3 from '../../assets/adv3.png';

const AdvantageSectionWrapper = styled.section`
  width: 100%;
  background-color: #fff;
  padding: 100px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  @media (max-width: 991px) {
    padding: 60px 0 0 0;
  }
`;

const AdvantageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  position: static;
  width: 100%;
  max-width: 1100px;
  margin-bottom: 30px;
  z-index: 10;
  @media (max-width: 991px) {
    position: static;
    padding: 0 20px;
    margin-bottom: 30px;
  }
`;

const AdvantageWhyExists = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1px;
`;

const AdvantageBracket = styled.span`
  font-family: 'Metrophobic', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 125%;
  letter-spacing: -0.02em;
  color: #202023;
`;

const AdvantageWhyExistsText = styled.span`
  font-family: 'Metrophobic', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 130%;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #202023;
`;

const AdvantageMainTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 79.6px;
  line-height: 100%;
  text-align: center;
  letter-spacing: -0.01em;
  color: #202023;
  margin: 0;
  white-space: nowrap;
  @media (max-width: 991px) {
    font-size: 40px;
    white-space: normal;
  }
`;

const AdvantageCardsContainer = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding-bottom: 45px;
  position: relative;

  @media (max-width: 991px) {
    gap: 30px;
    padding-bottom: 50px;
  }
`;

const AdvantageStickyCardWrapper = styled(motion.div)`
  position: relative;
  width: 789px;
  min-height: 308px;
  background-color: ${props => props.$bgColor || '#fff'};
  border: 1px solid #202023;
  border-radius: 1px;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0 -10px 40px rgba(0,0,0,0.08); /* More pronounced top shadow for stacking */
  z-index: ${props => props.$index + 1};

  @media (max-width: 991px) {
    position: static;
    width: 92%;
    height: auto; /* Let it grow naturally with content */
    min-height: 380px; 
    flex-direction: column;
    margin-bottom: 0;
    top: auto;
  }
`;

const AdvantageCardContent = styled.div`
  flex: 1;
  padding: 46px 60.64px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (max-width: 991px) {
    padding: 30px;
  }
`;

const AdvantageStickyCardTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 24px;
  line-height: 130%;
  letter-spacing: -0.02em;
  color: #202023;
  margin: 0;
  height: 31px;
`;

const AdvantageStickyCardDesc = styled.p`
  font-family: 'Metrophobic', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: -0.02em;
  color: #202023;
  width: 353.76px;
  white-space: pre-line; /* Respects line breaks and paragraph spacing */
  margin-top: 15px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const AdvantageStickyCardIllustration = styled.img`
  width: 386.36px;
  height: auto;
  max-height: 100%;
  object-fit: contain;
  object-position: bottom right;
  position: absolute;
  right: 0px;
  bottom: 0px; /* Aligned to bottom as requested */
  @media (max-width: 991px) {
    position: relative;
    width: 100%;
    height: auto;
    max-height: 200px;
    object-position: center;
  }
`;

const AdvantageCard = ({ title, description, illustration, bgColor, index }) => {
  return (
    <AdvantageStickyCardWrapper
      $bgColor={bgColor}
      $index={index}
    >
      <AdvantageCardContent>
        <AdvantageStickyCardTitle>{title}</AdvantageStickyCardTitle>
        {description && <AdvantageStickyCardDesc>{description}</AdvantageStickyCardDesc>}
      </AdvantageCardContent>
      {illustration && <AdvantageStickyCardIllustration src={illustration} />}
    </AdvantageStickyCardWrapper>
  );
};

export function AboutUs() {
  const navigate = useNavigate(); // Correctly placed useNavigate hook inside the component
  const [user, setUser] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false); // State to handle Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = React.useState(''); // State to store Snackbar message

  const handleJoinTheClubClick = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log('Login Failed:', error)
  });
 

  React.useEffect(
    () => {
      if (user) {
        console.log(user)
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((res) => {
            console.log(res)
            login(res.data)
          })
          .catch((err) => console.log(err));
      }
    },
    [user]
  );

  const login = async (user) => {
    console.log('loginapi:', user)
    try {
      const response = await axios.post(`${API_BASE_URL}/user/login`, {
        user: {
          name: user.name,
          email: user.email,
          id: user.id,
          profile_image: user.image
          // Other user data you might need
        },
      });
      console.log(response.data)
      if (response.data.is_success) {
        if (response.data.token) {
          axios({
            method: 'post',
            url: `${API_BASE_URL}/user/get-profile`,
            headers: {
              Authorization: response.data.token
            }
          }).then(res => {
            console.log(res.data);

            console.log(res.data.data[0]);
            if (res.data.data[0].pincode) {
              sessionStorage.setItem('token', response.data.token);

              navigate('/profile');
            } else {
              sessionStorage.setItem('token', response.data.token);
              navigate('/personalDetails');

            }

          }).catch(error => {
            console.error('Error fetching profile', error);
          });
        }

      } else {
        // Handle login failure
        setSnackbarMessage('Login failed. Please try again.');
        setSnackbarOpen(true);
      }
      return response.data;
    } catch (error) {
      console.error("Error registering user:", error);
      setSnackbarMessage('Login failed. Please try again.');
      setSnackbarOpen(true);
      return null;
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

 

  const data = [
      {
          id: 1,
          title: "FIRST",
          number: "10,000",
          description: "members will be honoured on our wall of elts",
          buttonText: "WHAT'S WALL OF ELTS?",
      },
  ];

  const advantageCards = [
    {
      title: "Demand-Driven Commerce",
      bgColor: "#FFFFFF",
      description: "Most platforms push products to consumers.\nSpoelt does the opposite.\n\nMembers tell us what they want to buy, and we curate deals around that demand. This ensures every deal on the platform is relevant, intentional, and community-backed.",
      illustration: adv1
    },
    {
      title: "Community Buying Power",
      bgColor: "#FFFFFF",
      description: "When multiple members want the same product,\nSpoelt groups that demand together.\n\nThis collective purchasing power allows us to negotiate exclusive deals that typical retail channels cannot offer.\n\nMembers don’t just shop individually.\nThey buy as a community.",
      illustration: adv2
    },
    {
      title: "Authentic Products Only",
      bgColor: "#FFFFFF",
      description: "Spoelt works directly with authorised distributors and import partners, ensuring members receive genuine products from trusted supply chains.\n\nNo marketplace confusion.\nNo questionable sellers.\n\nOnly verified products from leading brands.",
      illustration: adv3
    }
  ];
  return (
      <Container>
          <Section>
              <SectionImage src={window.innerWidth <= 991 ? hero_mobile : hero} alt="Hero" />

              <IntroductionSection>
                  <IntroductionColumn>
                      <SectionText>
                          [WHAT IS SPOELT?]<br />
                      </SectionText>

                  </IntroductionColumn>
                  <MissionColumn>
                      <MissionText>
                          <Paragraph>
                              Spoelt is a members only demand commerce platform which lets users list out products they wish to purchase immediately and/or purchase on an annual basis, but pay far less for their purchase compared to other retail channels.
                          </Paragraph>
                          <Paragraph2 marginTop="20px">
                              Spoelt's mission is to create the most organised consumer community in the world.
                          </Paragraph2>
                      </MissionText>
                  </MissionColumn>
              </IntroductionSection>
              <MarqueeBanner style={{ zIndex: 4, position: 'absolute', bottom: 0 }}>
                <Marquee>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                  <MarqueeText>WE ARE SPOELT&nbsp;&nbsp;&nbsp;&nbsp;</MarqueeText>
                </Marquee>
              </MarqueeBanner>
          </Section>

          <AdvantageSectionWrapper>
              <AdvantageHeader>
                  <AdvantageWhyExists>
                    <AdvantageBracket>[</AdvantageBracket>
                    <AdvantageWhyExistsText>why spoelt exists?</AdvantageWhyExistsText>
                    <AdvantageBracket>]</AdvantageBracket>
                  </AdvantageWhyExists>
                  <AdvantageMainTitle>The Spoelt Advantage</AdvantageMainTitle>
              </AdvantageHeader>
              <AdvantageCardsContainer>
                  {advantageCards.map((card, index) => (
                      <AdvantageCard 
                        key={index} 
                        {...card} 
                        index={index} 
                      />
                  ))}
              </AdvantageCardsContainer>
          </AdvantageSectionWrapper>

          <Container2>

              <Main >
                  <ContentWrapper>

                      <StepSection>

                          <StepText>
                              <span>[How does it work</span>? / STEP 01]
                          </StepText>
                      </StepSection>
                      <StepDescription>On sign up choose your persona</StepDescription>
                      <PersonaSelectionContainer>
                          <PersonaColumn>
                              <PersonaImage loading="lazy"  src={window.innerWidth <= 991 ? about_save_mobile : about_save}/>

                          </PersonaColumn>
                          <PersonaColumn>
                              <PersonaImage loading="lazy"  src={window.innerWidth <= 991 ? about_splurge_mobile : about_splurge} />
  
                          </PersonaColumn>
                      </PersonaSelectionContainer>
                  </ContentWrapper>
              </Main>

              <Main >
                  <ContentWrapper>
                      <StepSection marginTop="80px">
                          <StepText>
                              <span>[How does it work</span>? / STEP 02]
                          </StepText>
                      </StepSection>
                      <StepDescription>Fill in your lists!</StepDescription>
                      <StepImage loading="lazy" src={about_lists} />
                  </ContentWrapper>

              </Main>

              <WaitlistContainer>
                
                  <WaitlistContent>
                      <StepSection style={{ marginTop: 50 }}>

                          <StepText>
                              <span>[How does it work</span>? / STEP 03]
                          </StepText>
                      </StepSection>
                      <StepHeading>You have successfully joined our curation list!</StepHeading>
                      <WaitlistText>
                          Your products are being grouped with other community members for curating the best deals
                      </WaitlistText>
                      
                  </WaitlistContent>
                  <WaitlistImage loading="lazy"
                      src={window.innerWidth <= 991 ? about_success_mobile : about_success} />
              </WaitlistContainer>


              <DealsSection>
                  <DealsContent>
                      <HeadingContainer>
                          <Heading>Welcome to </Heading>
                          <Image loading="lazy" src={aboutPageImage} />
                      </HeadingContainer>
                      <DealsText>
                      We're currently onboarding more like-minded users, limited subscriptions are now open and product curation as per your lists will begin shortly.
                      </DealsText>
                      <DealsImage loading="lazy" src={FeatureImage} />
                      <Subtitle>
                          We are currently accepting only [50K users registrations]
                      </Subtitle>
                      <PresentationSection>
                          <PresentationText>[PRESENTING]</PresentationText>
                      </PresentationSection>
                      <DealsBoard>⬩Our Dealsboard⬩</DealsBoard>
                      <DealsDescription>
                          Unlike other e-commerce platforms, we believe less is more. Hence our dealsboard only shows 15 items which are:
                      </DealsDescription>
                      <DealsItems>
                          <DealsItem>5 from your lists</DealsItem>
                          <DealsPlus>+</DealsPlus>
                          <DealsItem>5 trending community deals</DealsItem>
                          <DealsPlus>+</DealsPlus>
                          <DealsItem>5 exclusive launches</DealsItem>
                      </DealsItems>
                      <LimitedMerchandise style={{ textAlign: 'center' }}>
                          Limited edition merchandise and giveaways are promoted on our dedicated <span style={{ textDecoration: 'underline', textDecorationStyle: 'wavy', cursor: 'pointer' }} onClick={() => navigate('/elts', { state: { merch: true } })}>merch</span> page.
                      </LimitedMerchandise>
                  </DealsContent>
              </DealsSection>

              <Main2>
                  <ContentWrapper2>
                      {data.map((item, index) => (
                          <FeatureSection key={index}>
                              <FeatureContent>
                                  <FeatureTitle>
                                      <FeatureLeftBracket>[</FeatureLeftBracket>
                                      <FeatureTitleText>{item.title}</FeatureTitleText>
                                      <FeatureRightBracket>]</FeatureRightBracket>
                                  </FeatureTitle>
                                  <FeatureNumber>{item.number}</FeatureNumber>
                                  <FeatureDescription>{item.description}</FeatureDescription>
                                  <FeatureButton  onClick={() => navigate('/elts', { state: { elts: true } })}>
                                      <FeatureButtonText>{item.buttonText}</FeatureButtonText>
                                      <FeatureButtonIcon src={featureButtonIcon} alt="Feature Button Icon" />
                                  </FeatureButton>
                              </FeatureContent>
                          </FeatureSection>
                      ))}
                      <JoinUsSection>
                          <JoinUsContent>
                              <JoinUsTitle>Join Us</JoinUsTitle>
                              <LimitedMerchandise>
                                  We are building in stealth and launching communities in Goa, Karnataka, Maharashtra & more regions.
                              </LimitedMerchandise>
                              <JoinClubButton onClick={handleJoinTheClubClick}>
                                  <JoinClubText>Join the club</JoinClubText>
                                  <JoinClubIcon src={joinClubIcon} alt="Join Club Icon" />
                              </JoinClubButton>
                          </JoinUsContent>
                      </JoinUsSection>
                  </ContentWrapper2>
              </Main2>

              <StepImage loading="lazy" src={about_join_us} />


          </Container2>
          <div style={{
              display: "flex",
              width: "100%",
              maxWidth: "100%",
              flexDirection: "column",
              backgroundColor: "#eaebef",
              alignItems: "center",
              color: "#202023",
              fontWeight: 400,
              lineHeight: "130%",
              paddingTop: "50px",
              paddingBottom: "50px",
          }}
          >
              <Image2 loading="lazy" src={contentImage} alt="" />

              <TaglineWrapper>
                  <TaglineLeft>[</TaglineLeft>
                  <TaglineCenter>WE ARE</TaglineCenter>
                  <TaglineRight>]</TaglineRight>
              </TaglineWrapper>

              <Subtitle2>Disrupting e-commerce one purchase at a time</Subtitle2>

              <ButtonWrapper>
                  <Button onClick={() => navigate('/')}>
                      <span style={{ color: 'black' }}>Home</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                  </Button>

                  <Button onClick={() => navigate('/privacy')}>
                      <span style={{ color: 'black' }}>Policies</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                  </Button>

                  <Button onClick={() => navigate('/privacy#brands')}>
                      <span>Brands</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                  </Button>



                  <LoginButton onClick={handleJoinTheClubClick}>
                      <span style={{ color: 'black' }}>Already a member? login</span>
                      <ButtonIcon loading="lazy" src={buttonIcon} alt="" />
                  </LoginButton>
              </ButtonWrapper>
          </div>
      </Container>
  );
}



const Container = styled.div`
//height: 300vh; // 100vh for each of the three sections
width: 100%; // Making the container full width
scroll-behavior: smooth;
@media (max-width: 991px) {
   /* overflow-x:hidden; Removed because it breaks position: sticky down the tree */
  }
`;
const Container2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 0;
  }
`;
const HeroSection = styled.div`
width:768px; align-self:center;
@media (max-width: 991px) {
  width: 100%;
}

`;
const Section = styled.div`
  height: 100vh;
  width: 100%; // Making the section full width
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 991px) {
    height: 600px;
  }
`;
const SectionImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const HeaderTextContainer = styled.div`
  display: flex;
  font-size: 16px;
  color: #202023;
  font-weight: 400;
  letter-spacing: -0.32px;
  align-self: end;
  margin-right: 104px;
  gap: 1px;
  @media (max-width: 991px) {
    margin-right: 10px;
  }
`;

const Bracket = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const HeaderTitle = styled.p`
  letter-spacing: 0.24px;
  margin: auto 0;
  font: 12px/130% Metrophobic, sans-serif;
`;

const SectionText = styled.div`
display: flex;
justify-content: right;

color: #202023;
  font-size: 12px;
  font-family: 'Metrophobic', sans-serif;
  text-align: center;
  z-index: 1;
  @media (max-width: 991px) {
   text-align: left;
   justify-content: left;
   margin-left:30px;
  padding-right: 10px;
padding-left: 40px;
  }
`;

const SectionSubText = styled.div`
display: flex;
color: #202023;
  font-size: 21px;
  font-family: 'Metrophobic', sans-serif;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0.5px;
  bottom: 50px;

  z-index: 1;
  @media (max-width: 991px) {
    text-align: left;
    bottom: 20%;
    left: 10%;
   }
`;

const MarqueeBanner = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  background-color: #E9FE53;
  padding: 10px 0;
  border-bottom: 1px solid #000;
  border-top: 1px solid #000;
`;

const Marquee = styled.div`
  display: flex;
  animation: marquee 15s linear infinite; // Continuous scrolling effect
  @keyframes marquee {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); } // Adjust based on the number of items
  }
`;

const MarqueeText = styled.div`
  font-size: 14px;
  color: #202023;
  padding: 0 2rem;
  white-space: nowrap; // Prevent text wrapping
`;
const Main = styled.main`
  align-self: center; // Center aligned
  z-index: 10;
  
  @media (max-width: 991px) {
    max-width: 100%;
   // margin-top: 40px;
  }
`;
const Main2 = styled.main`
  align-self: center; // Center aligned
  z-index: 10;
  width:90%;
  max-width: 1100px;
  margin-top: 137px;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 0px;
    width:100%;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;
const ContentWrapper2 = styled.div`
  display: flex;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;
const FeatureSection = styled.section`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 0px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const FeatureContent = styled.div`
  border: 1px solid rgba(0, 0, 0, 1);
  background-color: #171717;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  line-height: 130%;
  padding: 14px 50px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const FeatureTitle = styled.h3`
  align-self: start;
  display: flex;
  gap: 1px;
  font-weight: 500;
  white-space: nowrap;
  text-align: right;
  letter-spacing: -0.32px;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const FeatureLeftBracket = styled.span`
  font-family: Manrope, sans-serif;
`;

const FeatureTitleText = styled.span`
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
`;

const FeatureRightBracket = styled.span`
  font-family: Manrope, sans-serif;
`;

const FeatureNumber = styled.div`
  letter-spacing: -5.2px;
  margin-bottom: 15px;
  text-transform: uppercase;
  margin-top: 17px;
  font: 900 130px/86% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 92px;
  }
`;

const FeatureDescription = styled.p`
  margin: 0 21px 0 0;
  font: 20px/102% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-right: 10px;
  }
`;
const Button = styled.button`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  padding: 16px 13px;
  font-family: Metrophobic, sans-serif;
  cursor: pointer;
  width:260px;  
  text-transform: uppercase;
  white-space: nowrap;
  @media (max-width: 991px) {
   
    width: 96%;
  }

`;
const FeatureButton = styled(Button)`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid rgba(32, 32, 35, 1);
  background-color: #e9fe53;
  display: flex;
  margin-top: 34px;
  gap: 8px;
  color: #202023;
  text-transform: uppercase;
  letter-spacing: -0.32px;
  padding: 20px 13px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    margin-top: 20px;
    margin-bottom: 20px;
width: 100%; 
  };
  width:50%
`;

const FeatureButtonText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const FeatureButtonIcon = styled.img`
  aspect-ratio: 1.1;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
 // border: 1px solid rgba(32, 32, 35, 1);
  margin: auto 0;
`;

const JoinUsSection = styled.section`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const JoinUsContent = styled.div`
  border: 1px solid rgba(0, 0, 0, 1);
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  color: #202023;
  font-weight: 400;
  line-height: 130%;
  padding: 10px 20px 35px 20px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const JoinUsTitle = styled.div`
  letter-spacing: -0.8px;
  margin-top: 36px;
  font: 800 80px Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    margin-bottom: 10px;
  }
`;
const PhoneNumberInput = styled.input`
align-items: start;
border-radius: 1.658px;
border: 2px solid rgba(32, 32, 35, 1);
// margin-top: 45px;
letter-spacing: -0.4px;
justify-content: center;
padding: 27px 22px;
font: 20px Metrophobic, sans-serif;
@media (max-width: 991px) {
  max-width: 100%;
  padding: 0 20px;
  height: 50px;
}
`;


const JoinClubButton = styled.div`
justify-content: space-between;
border-radius: 1.658px;
border: 2px solid rgba(32, 32, 35, 1);
background-color: #e9fe53;
display: flex;
margin-top: 25px;
gap: 13px;
font-size: 18px;
text-transform: uppercase;
letter-spacing: -0.36px;
padding: 27px 22px;
cursor: pointer; // Show mouse cursor on hover
@media (max-width: 991px) {
  max-width: 100%;
  flex-wrap: wrap;
  padding: 0 20px;
  height: 50px;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
`;

const JoinClubText = styled.span`
font-family: Metrophobic, sans-serif;
`;

const JoinClubIcon = styled.img`
aspect-ratio: 1.2;
object-fit: auto;
object-position: center;
width: 18px;
fill: #202023;
stroke-width: 1.658px;
stroke: #202023;
//border: 2px solid rgba(32, 32, 35, 1);
margin: auto 0;
`;
const HeaderImage = styled.img`
  aspect-ratio: 4.17;
  object-fit: cover;
  width: 100%;
  align-self: stretch;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ContentContainer = styled.div`
  align-self: stretch;
  z-index: 10;
  margin-top: -9px;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const IntroductionSection = styled.section`
margin-top:15%;
  gap: 20px;
  display: flex;
  @media (max-width: 991px) {
    margin-top:-40px;
    text-align:left;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const IntroductionColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 61%;
  margin-left: 0;
  @media (max-width: 991px) {
    width: 100%;
  }
`;


const MainImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  min-height: 397px;
  width: 100%;
  padding-top: 80px;
  align-items: start;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const MainImageOverlay = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const MainImage = styled.img`
  object-fit: cover;
  width: 100%;
  stroke-width: 1.143px;
  stroke: #000;
  border: 1px solid;
  margin-top: 315px;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
`;

const MissionColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 39%;
  margin-left: 20px;
  margin-right: 100px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const MissionText = styled.div`
  display: flex;
  flex-direction: column;
  color: #202023;
  padding: 0 20px;
  margin-top: 5px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const Paragraph = styled.p`
  font: 400 21px/27px Metrophobic, sans-serif;
  margin-top: ${(props) => props.marginTop || "0"};
  line-height: 130%;

  @media (max-width: 991px) {
    max-width: 100%;
    font: 400 16px Metrophobic, sans-serif;
    padding-right:10px;
    line-height: 130%;
    margin-top: 5px;
    padding-left: 30px;

  }
`;
const Paragraph2 = styled.p`
  font: 800 32px/27px Inter, sans-serif;
  margin-top: ${(props) => props.marginTop || "0"};
  @media (max-width: 991px) {
    max-width: 100%;
    font: 600 24px/24px Inter;
    padding-right:10px;
    margin-top: 5px;
    padding-left: 30px;

  }
`;
const RepetitiveTextSection = styled.section`
  align-self: stretch;
  display: flex;
  margin-top: 7px;
  padding-right: 20px;
  gap: 20px;
  font-size: 14px;
  color: #202023;
  font-weight: 400;
  letter-spacing: 0.28px;
  line-height: 130%;
  justify-content: space-between;
  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`;

const RepetitiveText = styled.p`
  font-family: Metrophobic, sans-serif;
`;

const StepSection = styled.section`
  display: flex;
  margin-top: ${(props) => props.marginTop || "45px"};
  padding-right: 20px;
  gap: 1px;
  font-size: 20px;
  color: #202023;
  font-weight: 400;
  letter-spacing: -0.4px;
  @media (max-width: 991px) {
    margin-top: 40px;
    align-self:center;
    padding:0px;

  }
`;

const StepText = styled.p`
  letter-spacing: 0.36px;
  text-transform: uppercase;
  font: 18px/130% Metrophobic, sans-serif;
 
`;

const StepDescription = styled.p`
  color: #202023;
  text-align: center;
  letter-spacing: -0.8px;
  margin-top: 21px;
  width: 823px;
  font: 800 80px/80px Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
    line-height: 44px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
`;

const PersonaSelectionContainer = styled.section`
  margin-top: 29px;
  width: 60%;
  max-width: 100%;
  flex-direction: row;
display:flex;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
    width: 95%;
    margin-top: 5px;
}
`;

const PersonaColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 10px;
  margin-right: 10px;

  @media (max-width: 991px) {
    width: 100%;
  }
`;



const StepImage = styled.img`
aspect-ratio: 1.54;
  object-fit: contain;
  object-position: center;
  width: 70%;
  margin-top: -18px;
  max-width: 100%;
  align-self:center;
  z-index:12;

@media (max-width: 991px) {
    margin-top: 5px;  
    width: 100%;}
   
`;
const PersonaImage = styled.img`

  object-fit: cover;
  width: 869px;
  margin-top: 17px;
  max-width: 100%;
`;

const WaitlistContainer = styled.section`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  align-self: stretch;
  position: relative;
  z-index: 10;
  min-height: 435px;
  margin-top: 40px;
 // width: 100%;
  align-items: center;
  justify-content: center;
  padding: 20px 60px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const WaitlistImage = styled.img`
 // position: absolute;
  inset: 0;
 // height: 100%;
  width: 100%;
  //object-fit: cover;
  @media (min-width: 991px) {
    height: 100%;    
    position: absolute;

  }
`;

const WaitlistContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 6px;
  width: 860px;
  max-width: 100%;
`;

const StepHeading = styled.div`
  text-align: center;
  letter-spacing: -0.8px;
  align-self: stretch;
  margin-top: 22px;
  font: 800 75px/75px Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 36px;
    line-height: 44px;
  }
`;

const WaitlistText = styled.p`
  text-align: center;
  letter-spacing: -0.42px;
  margin-top: 17px;
  margin-bottom:50px;
  width: 585px;
  font: 21px/27px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font: 16px/16px Metrophobic, sans-serif;

  }
`;

const DealsSection = styled.section`
  background-color: #e9fe53;
  align-self: stretch;
  display: flex;
  margin-top: -5px;
  //width: 100%;
  align-items: center;
  color: #202023;
  font-weight: 800;
  justify-content: center;
  padding: 80px 60px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const DealsContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 968px;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 23px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const HeadingContainer = styled.div`
  display: flex;
  gap: 20px;
  font-size: 80px;
  line-height: 108%;
  justify-content: space-between;
  @media (max-width: 991px) {
    flex-wrap: wrap;
    font-size: 40px;
    justify-content: center;
  }
`;

const Heading = styled.div`
  font-family: Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 50px;
  }
`;

const Image = styled.img`
  aspect-ratio: 4;
  object-fit: cover;
  width: 332px;
  align-self: start;
  margin-top: 8px;
  @media (max-width: 991px) {
    height:50px;
    object-fit: fill;
  }
`;

const DealsText = styled.p`
  text-align: center;
  letter-spacing: -0.28px;
  margin-top: 25px;
  width: 600px;
  font: 400 14px/18px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const DealsImage = styled.img`
  //aspect-ratio: 3.23;
  object-fit: cover;
  width: 586px;
  margin-top: 16px;
  max-width: 100%;
`;

/* const Subtitle = styled.p`
  text-align: center;
  margin-top: 17px;
  font: 20px/108% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`; */

const PresentationSection = styled.section`
  display: flex;
  margin-top: 114px;
  gap: 1px;
  font-size: 20px;
  font-weight: 400;
  white-space: nowrap;
  letter-spacing: -0.4px;
  @media (max-width: 991px) {
    margin-top: 40px;
    white-space: initial;
  }
`;

const PresentationText = styled.div`
  letter-spacing: 0.36px;
  text-transform: uppercase;
  font: 18px/130% Metrophobic, sans-serif;
`;

const DealsBoard = styled.div`
  text-align: center;
  letter-spacing: -0.8px;
  margin-top: 21px;
  font: bold 80px/100% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 32px;
  }
`;

const DealsDescription = styled.div`
  text-align: center;
  letter-spacing: -0.42px;
  margin-top: 35px;
  width: 744px;
  font: 400 21px/27px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 20px;
    letter-spacing: -0.28px;
margin-botton:20px;
    font: 400 14px/14px Metrophobic, sans-serif;
  }
`;

const DealsItems = styled.div`
  align-self: stretch;
  display: flex;
  margin-top: 38px;
  width: 100%;
  gap: 20px;
  font-size: 40px;
  text-align: center;
  letter-spacing: -0.4px;
  line-height: 40px;
  @media (max-width: 991px) {
    display: block;
    max-width: 100%;
    flex-wrap: wrap;
    font-size: 20px;
    justify-content:center;
  }
`;

const DealsItem = styled.div`
  font-family: Inter, sans-serif;
  @media (max-width: 991px) {
    line-height: 10px;
  }
`;

const DealsPlus = styled.span`
  font-family: Inter, sans-serif;
  line-height: 100%;
  margin: auto 0;
  @media (max-width: 991px) {
    line-height: 10px;
  }
`;

const LimitedMerchandise = styled.p`
  text-align: left;
  letter-spacing: -0.42px;
  margin-top: 42px;
  font: 400 21px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
    font-size: 14px;
    text-align:center;
  }
`;

const WallOfEltsSection = styled.section`
  width: 100%;
  display: flex;
  max-width: 1205px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const WallOfEltsContent = styled.div`
  gap: 20px;
  display: flex;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }
`;

const WallOfEltsColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 0;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const WallOfEltsContainer = styled.div`
  border: 1px solid #202023;
  background-color: #171717;
  display: flex;
  flex-direction: column;
  color: #fff;
  font-size: 16px;
  line-height: 130%;
  padding: 63px 70px;
  @media (max-width: 991px) {
    padding: 0 20px;
  }
`;

const WallOfEltsText = styled.span`
  font-family: Metrophobic, sans-serif;
  letter-spacing: 0.32px;
`;

const WallOfEltsHeading = styled.h2`
  letter-spacing: -5.2px;
  text-transform: uppercase;
  margin-top: 17px;
  font: 900 130px/86% Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
  }
`;

const WallOfEltsDescription = styled.p`
  margin-right: 21px;
  font: 20px/102% Inter, sans-serif;
  @media (max-width: 991px) {
    margin-right: 10px;
  }
`;

const WallOfEltsTitle = styled.h3`
  text-align: center;
  letter-spacing: 0.32px;
  margin-top: 34px;
  font: 400 20px Metrophobic, sans-serif;
  text-transform: uppercase;
`;

const WallOfEltsIcon = styled.img`
  aspect-ratio: 1.1;
  object-fit: cover;
  width: 11px;
  fill: #202023;
  stroke: #202023;
  border: 1px solid #202023;
  margin: auto 0;
`;

const JoinUsColumn = styled.div`
  display: flex;
  flex-direction: column;
  line-height: normal;
  width: 50%;
  margin-left: 20px;
  @media (max-width: 991px) {
    width: 100%;
  }
`;

const JoinUsHeading = styled.h2`
  letter-spacing: -0.8px;
  font: 800 80px Inter, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
  }
`;

const JoinUsDescription = styled.p`
  letter-spacing: -0.42px;
  margin-top: 50px;
  font: 21px/27px Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
`;

const JoinUsButton = styled.div`
  justify-content: space-between;
  border-radius: 1.658px;
  border: 2px solid #202023;
  background-color: #e9fe53;
  display: flex;
  margin-top: 28px;
  gap: 13px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: -0.36px;
  padding: 27px 22px;
  @media (max-width: 991px) {
    max-width: 100%;
    flex-wrap: wrap;
    padding: 0 20px;
  }
`;

const JoinUsText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const JoinUsIcon = styled.img`
  aspect-ratio: 1.12;
  object-fit: cover;
  width: 18px;
  fill: #202023;
  stroke: #202023;
  border: 2px solid #202023;
  margin: auto 0;
`;

const Footer = styled.footer`
  border: 1px solid #202023;
  background-color: #eaebef;
  align-self: stretch;
  display: flex;
  width: 100%;
  align-items: center;
  color: #202023;
  justify-content: center;
  padding: 80px 60px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 18px 0 58px;
  width: 792px;
  max-width: 100%;
  @media (max-width: 991px) {
    margin-bottom: 40px;
  }
`;

const FooterImage = styled.img`
  aspect-ratio: 4.17;
  object-fit: cover;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const FooterTextContainer = styled.div`
  align-self: center;
  display: flex;
  margin-top: 22px;
  gap: 1px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;
`;

const FooterTitle = styled.h2`
  text-align: right;
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
`;

const FooterSubtitle = styled.p`
  text-align: center;
  letter-spacing: -0.42px;
  align-self: center;
  margin-top: 20px;
  font: 21px Metrophobic, sans-serif;
`;

const FooterLinks = styled.nav`
  display: flex;
  margin-top: 24px;
  gap: 5px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.28px;
  padding: 0 1px;
  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`;

const FooterLink = styled.a`
  justify-content: space-between;
  border-radius: 1px;
  border: 1px solid #202023;
  background-color: #e9fe53;
  display: flex;
  gap: 8px;
  white-space: nowrap;
  padding: 16px 13px;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const FooterLinkText = styled.span`
  font-family: Metrophobic, sans-serif;
`;

const FooterIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: cover;
  width: 11px;
  fill: #202023;
  stroke: #202023;
  border: 1px solid #202023;
  margin: auto 0;
`;

const Image2 = styled.img`
  aspect-ratio: 4.17;
  object-fit: auto;
  object-position: center;
  width: 60%;
  margin-top: 20px;
`;

const TaglineWrapper = styled.div`
  align-self: center;
  display: flex;
  margin-top: 22px;
  gap: 1px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;

`;

const TaglineLeft = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const TaglineCenter = styled.div`
  text-align: right;
  font-family: Metrophobic, sans-serif;
  font-weight: 400;
  letter-spacing: 0.32px;
  @media (max-width: 991px) {
    font-size: 14px;
    margin-top: 10px;
  }
`;

const TaglineRight = styled.div`
  font-family: Manrope, sans-serif;
  @media (max-width: 991px) {
    font-size: 16px;
    margin-top: 10px;
  }
`;

const Subtitle = styled.div`
  text-align: center;
  letter-spacing: -0.42px;
  align-self: center;
  margin-top: 20px;
  font: bold 21px Inter, sans-serif;
  @media (max-width: 991px) {
    font-size: 20px;
    margin-top: 10px;
    font: bold 21px Inter, sans-serif;

  }
`;
const Subtitle2 = styled.div`
  text-align: center;
  letter-spacing: -0.42px;
  align-self: center;
  margin-top: 20px;
  font:  21px Inter, sans-serif;
  @media (max-width: 991px) {
    margin-top: 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  gap: 5px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: -0.28px;
  padding: 0 1px;
  
  @media (max-width: 991px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`;



const ButtonIcon = styled.img`
  aspect-ratio: 1.22;
  object-fit: auto;
  object-position: center;
  width: 11px;
  fill: #202023;
  stroke-width: 1px;
  stroke: #202023;
 // border: 1px solid rgba(32, 32, 35, 1);
  margin: auto 0;
`;

const LoginButton = styled(Button)`
  white-space: nowrap;
  
  @media (max-width: 991px) {
    white-space: initial;
  }
`;
